import { useMutation, useQueryClient } from '@tanstack/react-query';
import { TransportersApi } from 'api';

/**
 *  Custom React Query hook to update a carrier
 *
 * @param {number} id
 * @param {{ onSuccess?: () => void; onError?: (error: Error) => void }} options
 * @returns {import('@tanstack/react-query').UseMutationResult}
 */
export const useUpdateTransporter = (id, { onSuccess, onError } = {}) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data) => TransportersApi.update(id, data),
    onSuccess: () => {
      queryClient.invalidateQueries(['transporters']);
      typeof onSuccess === 'function' && onSuccess();
    },
    onError: (error) => {
      typeof onError === 'function' && onError(error);
    },
  });
};
